import * as React from "react";
import { useState } from "react";
import styled from "@mui/material/styles/styled";
import { QualifiedFeature } from "fe-common/graphql";
import { ACTION, CATEGORY, evt } from "fe-common/analytics/analytics";
import { DesktopOnly } from "../util/desktopOnly";
import { ClinicalReasoningIconDesktop } from "../common/clinicalReasoningIconDesktop";
import { MobileOnly } from "../util/mobileOnly";
import { ClinicalReasoningIconMobile } from "../common/clinicalReasoningIconMobile";
import { truncate } from "lodash";
import { MobileClinicalReasoning } from "../common/procedureItem";
import { QualifierValue } from "./refineByRelation";
import { useScreenSize } from "../util/useScreenSize";
import { QualifierWithSelection } from "./refineFeaturePanel";

//region [[ Styles ]]

const RelationRowView = styled("div")(({ theme }) => ({}));

const QualifierContainer = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
}));

//endregion [[ Styles ]]

//region [[ Props ]]

export interface RelationRowProps {
  qualifier: QualifierWithSelection;
  onAdd: any;
  onRemove: any;
  causedByDisease: any;
  qf: QualifiedFeature;
  disabled?: boolean;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const RelationRow = ({ ...props }: RelationRowProps) => {
  const { isMobile } = useScreenSize();
  const [showClinicalReasoning, setShowClinicalReasoning] = useState(false);

  const onShowClinicalReasoning = () => {
    if (!isMobile) return;
    evt({
      category: CATEGORY.PLAN,
      action: showClinicalReasoning
        ? ACTION.HIDE_CLINICAL_REASONING
        : ACTION.SHOW_CLINICAL_REASONING,
      label: props.qualifier.qualifier.value.name,
    });

    setShowClinicalReasoning(!showClinicalReasoning);
  };

  const onClickRefinement = () => {
    if (
      props.qualifier.negated
      // @TODO - bring back while figuring out with @chen
      //|| (props.qualifier.canBeNegated === false && props.qualifier.selected)
    ) {
      props.onRemove(props.qualifier.qualifier);
    } else if (props.qualifier.selected) {
      props.onAdd({ ...props.qualifier.qualifier, negate: true });
    } else {
      props.onAdd({ ...props.qualifier.qualifier });
    }
  };

  return (
    <RelationRowView>
      <QualifierContainer>
        <QualifierValue
          variant={"outlined"}
          size="small"
          clicked={props.qualifier.selected ? "true" : "false"}
          disabled={props.qualifier.disabled || props.disabled === true}
          onClick={onClickRefinement}
        >
          {props.qualifier.negated === true ? "No " : ""}
          {truncate(props.qualifier.qualifier.value.name, {
            length: 35,
          })}

          {props.causedByDisease && props.causedByDisease.length > 0 && (
            <DesktopOnly>
              <ClinicalReasoningIconDesktop
                suggestion={{
                  finding: props.qf,
                  causedByDisease: props.causedByDisease,
                }}
                qualifier={props.qualifier.qualifier}
              />
            </DesktopOnly>
          )}
        </QualifierValue>
        {props.causedByDisease && (
          <MobileOnly>
            <ClinicalReasoningIconMobile
              showClinicalReasoning={showClinicalReasoning}
              onShowClinicalReasoning={onShowClinicalReasoning}
              suggestion={{
                finding: props.qf,
                causedByDisease: props.causedByDisease,
              }}
              qualifier={props.qualifier.qualifier}
            />
          </MobileOnly>
        )}
      </QualifierContainer>

      {showClinicalReasoning && (
        <MobileClinicalReasoning
          show={showClinicalReasoning}
          suggestion={{
            finding: props.qf,
            causedByDisease: props.causedByDisease,
          }}
          qualifier={props.qualifier.qualifier}
        />
      )}
    </RelationRowView>
  );
};
